import BaseAPI from './BaseAPI'

export default class GroupAPI extends BaseAPI {
    static getGroups() {
        return this.execute('get', '/groups')
    }

    static getGroup(id) {
        return this.execute('get', `/groups/${id}`)
    }

    static createGroup(data) {
        return this.execute('post', '/groups', data)
    }

    static updateGroup(id, data) {
        return this.execute('patch', `/groups/${id}`, data)
    }

    static deleteGroup(id) {
        return this.execute('delete', `/groups/${id}`)
    }
}



// WEBPACK FOOTER //
// ./src/api/GroupAPI.js